export function getAttention({ totalNegocios, totalFechamentos, visitasMes }) {
  // 🔴 RISCO
  if (totalNegocios === 0 && visitasMes === 0) {
    return {
      tipo: 'risco',
      texto: 'Negócio parado morre.',
    };
  }

  // 🟡 AJUSTE
  if (visitasMes > 0 && totalFechamentos === 0) {
    return {
      tipo: 'ajuste',
      texto: 'O esforço existe, falta ajuste.',
    };
  }

  // 🔵 TENSÃO POSITIVA
  return {
    tipo: 'tensao',
    texto: 'Você está bem, mas ainda abaixo do potencial do seu nível.',
  };
}
